<template>
    <div class="Lrheader">
        <ul class="header-ul">
            <li>
                <img src="../../assets/imags/header1.png" alt="">
                <div class="header-typeface">多店铺管理</div>
            </li>
            <li>
                <img src="../../assets/imags/header2.png" alt="">
                <div class="header-typeface">一键定价</div>
            </li>
            <li>
                <img src="../../assets/imags/header3.png" alt="">
                <div class="header-typeface">一键翻译</div>
            </li>
            <li>
                <img src="../../assets/imags/header4.png" alt="">
                <div class="header-typeface">物流管理</div>
            </li>
            <li>
                <img src="../../assets/imags/header5.png" alt="">
                <div class="header-typeface">财务管理</div>
            </li>
            <li>
                <img src="../../assets/imags/header6.png" alt="">
                <div class="header-typeface">权限管理</div>
            </li>
        </ul>
        <div class="header-right">
            <img src="../../assets/imags/investment1.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
  name: 'Lrheder',
  data() {
      return{}
  },
  mounted() {
    
  },
  created() {
      
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
    .Lrheader{
        height: calc(100% - 77% - 65px);
        display: flex;
        align-items: flex-end;
        .header-ul{
            width: 65%;
            // height: 100%;
            float: left;
            display: flex;
            justify-content: space-around;
            text-align: center;
            li{
                width: 16%;
                img{
                    width: 75px;
                    height: 75px;
                    display: inline-block;
                    // margin-left: 30%
                }
                .header-typeface{
                    font-size: 18px;
                    line-height: 40px;
                    text-align: center;
                }
            }
        }
        .header-right{
            width: 25%;
            height: 100%;
            float: right;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
</style>